function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTovala = function SvgTovala(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.862 23.415V1.272h2.924v19.554h11.086v2.589h-14.01Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m117.076 1.272-8.498 22.112h2.924l1.827-4.751h10.66l1.919 4.751h3.046l-8.62-22.112h-3.258Zm1.583 3.442-4.355 11.3h8.772l-4.417-11.3ZM162.121 1.242l-8.497 22.112h2.924l1.827-4.751h10.66l1.919 4.75H174l-8.62-22.11h-3.259Zm1.584 3.442-4.355 11.3h8.772l-4.417-11.3Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.465 23.476-8.42-22.234h3.143l6.863 18.366 6.833-18.366h3.081l-8.328 22.234h-3.172Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.657 12.328c.146-9.137 6.76-11.4 10.048-11.39v2.437c-2.37.038-6.96 1.859-7.064 8.93-.103 7.074 4.608 8.924 7.064 8.977v2.498c-3.41-.01-10.195-2.315-10.048-11.452Zm10.049 8.954v2.498c3.41-.01 10.195-2.315 10.048-11.452-.147-9.137-6.76-11.4-10.048-11.39v2.437h.09v-.001c2.342-.008 7.052 1.767 7.156 8.93.105 7.164-4.726 8.97-7.155 8.979l-.091-.001Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.242h7.492v7.492H0zM0 15.983h7.492v7.492H0zM14.741 1.242h7.492v7.492h-7.492zM14.741 15.983h7.492v7.492h-7.492zM40.629 3.861V1.272h18v2.59h-7.432v19.553h-2.954V3.86H40.63Z",
    fill: props.color,
    stroke: props.color
  })));
};
export default SvgTovala;